angular.module('tgaAdmin')
  .controller('LoginTwoFactorController', [
    '$scope', '$state', '$location', 'userService', 'settingsService', 'domainService', '$uibModal',
    function (
      $scope, $state, $location, userService, settingsService, domainService, $uibModal,
    ) {
      $scope.checkingCookie = true;

      if (userService.isLoggedIn()) {
        $state.go('v1.games');
        return;
      }
      $scope.checkingCookie = false;

      $scope.data = {
        alerts: [],
        logo: '',
        defaultLogo: './v1/assets/images/logo-black.svg',
      };

      $scope.viewmodel = {
        two_factor_secret: '',
        two_factor_remember: false,
        attempts: 0,
        resend: false,
      };

      $scope.initialize = function () {
        settingsService.getSettings().then((settings) => {
          $scope.data.logo = settings.logo || $scope.data.defaultLogo;
        });
      };

      $scope.actions = {
        submit() {
          $scope.data.alerts = [];

          if ($scope.twoFactorForm.$invalid) {
            return;
          }

          $scope.loading = true;
          $scope.viewmodel.resend = false;

          userService.loginTwoFactor($scope.viewmodel).then(() => {
            if (domainService.isDomainLoggingRequired(userService.getUserData(), domainService.domain)) {
              $scope.actions.domainLoggingModal();
            } else {
              $scope.loading = false;
              $state.go('v1.games');
            }
          }, () => {
            $scope.loading = false;
            $scope.actions.clearCodeField();
            $scope.actions.createAlert('Authentication code is not accepted. '
              + 'Please try again or click resend to receive a new code. Codes expire after 20 minutes', 'danger');
          });
        },
        domainLoggingModal() {
          $uibModal
            .open({
              animation: true,
              templateUrl: 'templates/partials/modal-domain-logging.html',
              controller: 'DomainLoggingController',
              backdrop: true,
              size: 'lg',
              resolve: {
                desiredDomain: () => domainService.domain,
                externalLogin: () => true,
              },
            })
            .result.then((reason) => {
              const { submitted } = reason;
              $scope.loading = false;
              if (submitted) {
                $state.go('v1.games');
              }
            })
            .catch(() => {
              $scope.loading = false;
              userService.logout();
              $state.go('v1.login');
            });
        },
        resendCode() {
          $scope.resending = true;
          $scope.viewmodel.resend = true;
          userService.loginTwoFactor($scope.viewmodel).then(() => {
            $scope.resending = false;
            $scope.actions.clearCodeField();
            $scope.actions.createAlert('New code has been sent.');
          }, () => {
            $scope.resending = false;
            $scope.actions.clearCodeField();
            $scope.actions.createAlert('Error sending code. Please try again.', 'danger');
          });
        },
        clearCodeField() {
          $scope.viewmodel.two_factor_secret = '';
        },
        createAlert(msg, type) {
          $scope.data.alerts = [];
          $scope.data.alerts.push({
            msg,
            type,
          });
        },
      };

      $scope.initialize();
    },
  ]);
